(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bouquet-upcoming-events"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bouquet-upcoming')) return;
  customElements.define('bouquet-upcoming', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._track = this.querySelector('[data-bq-event-track]');
      this._controls = this.querySelector('[data-bq-event-controls]');
      this._previous = this.querySelector('[data-bq-event-prev]');
      this._next = this.querySelector('[data-bq-event-next]');
      this._count = this.querySelector('[data-bq-event-count]');
      this._desktop = matchMedia('(min-width: 750px)');
      this._reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this._index = 0;
      this._target = null;
      this._on(this._previous, 'click', () => this._go((this._target ?? this._index) - 1));
      this._on(this._next, 'click', () => this._go((this._target ?? this._index) + 1));
      this._on(this._track, 'scroll', () => this._schedule(), { passive: true });
      this._on(this._track, 'scrollend', () => { this._target = null; this._update(); });
      this._on(this._track, 'pointerdown', () => { this._target = null; }, { passive: true });
      this._on(this._track, 'keydown', (event) => {
        if (this._desktop.matches || event.target !== this._track) return;
        const current = this._target ?? this._index;
        const rtl = getComputedStyle(this._track).direction === 'rtl';
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this._items.length - 1;
        else if (event.key === (rtl ? 'ArrowLeft' : 'ArrowRight')) next = current + 1;
        else if (event.key === (rtl ? 'ArrowRight' : 'ArrowLeft')) next = current - 1;
        else return;
        event.preventDefault();
        this._go(next);
      });
      this._on(this._desktop, 'change', () => this._update());
      this._on(document, 'visibilitychange', () => { if (!document.hidden) this._refresh(); });
      this._on(document, 'shopify:block:select', (event) => {
        const index = this._items.findIndex((item) => item === event.target || item.contains(event.target));
        if (index >= 0 && !this._desktop.matches) this._go(index, true);
      });
      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(() => this._schedule());
        this._resize.observe(this._track);
      }
      this._refresh();
    }

    _on(target, event, callback, options = {}) {
      target?.addEventListener(event, callback, { ...options, signal: this._abort.signal });
    }

    _refresh() {
      clearTimeout(this._expiryTimer);
      const now = Date.now() / 1000;
      const cards = [...this.querySelectorAll('[data-bq-event]')];
      const designMode = this.dataset.designMode === 'true';
      cards.forEach((card) => {
        if (!designMode && Number(card.dataset.eventExpiry) <= now) card.remove();
      });
      this._items = [...this.querySelectorAll('[data-bq-event]')];
      this.hidden = this._items.length === 0;
      const scheduleLink = this.closest('bouquet-world')?.querySelector('[data-bq26-schedule-link]');
      if (scheduleLink) scheduleLink.hidden = this.hidden;
      if (this.hidden) return;
      this._update();
      if (!designMode) {
        const nextExpiry = Math.min(...this._items.map((card) => Number(card.dataset.eventExpiry)));
        this._expiryTimer = setTimeout(() => this._refresh(), Math.min(86400000, Math.max(1000, (nextExpiry - now) * 1000 + 50)));
      }
    }

    _schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => { this._frame = 0; this._update(); });
    }

    _update() {
      if (!this._items?.length) return;
      const desktop = this._desktop.matches;
      this._controls.hidden = desktop || this._items.length < 2;
      this._track.tabIndex = desktop ? -1 : 0;
      if (desktop) return;
      const rect = this._track.getBoundingClientRect();
      const rtl = getComputedStyle(this._track).direction === 'rtl';
      const edge = rtl ? rect.right : rect.left;
      let nearest = 0;
      let distance = Infinity;
      this._items.forEach((item, index) => {
        const bounds = item.getBoundingClientRect();
        const difference = Math.abs((rtl ? bounds.right : bounds.left) - edge);
        if (difference < distance) { distance = difference; nearest = index; }
      });
      this._index = nearest;
      this._previous.disabled = nearest === 0;
      this._next.disabled = nearest === this._items.length - 1;
      const text = `${nearest + 1} / ${this._items.length}`;
      if (this._count.textContent !== text) this._count.textContent = text;
    }

    _go(index, instantly = false) {
      const next = Math.max(0, Math.min(this._items.length - 1, index));
      const trackRect = this._track.getBoundingClientRect();
      const itemRect = this._items[next].getBoundingClientRect();
      const rtl = getComputedStyle(this._track).direction === 'rtl';
      this._target = next;
      this._track.scrollBy({ left: rtl ? itemRect.right - trackRect.right : itemRect.left - trackRect.left, behavior: instantly || this._reduced.matches || this.closest('bouquet-world')?.dataset.motion === 'off' ? 'instant' : 'smooth' });
      this._schedule();
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._resize?.disconnect();
      clearTimeout(this._expiryTimer);
      cancelAnimationFrame(this._frame);
      this._abort = null;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanakatsu-participant-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fn-participant-slideshow')) {
    customElements.define('fn-participant-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.initialize = () => {
          if (this.abort) return;
          this.track = this.querySelector('.fnps__track');
          this.slides = [...this.querySelectorAll('.fnps__slide')];
          if (this.slides.length < 2) return;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.playing = !this.motion.matches;
          this.visible = false;
          this.hovering = false;
          this.index = 0;
          this.querySelector('.fnps__controls').hidden = false;
          this.querySelector('[data-prev]').addEventListener('click', () => this.go(-1, true), options);
          this.querySelector('[data-next]').addEventListener('click', () => this.go(1, true), options);
          this.togglePointerState = null;
          this.querySelector('[data-toggle]').addEventListener('pointerdown', () => { this.togglePointerState = this.playing; }, options);
          this.querySelector('[data-toggle]').addEventListener('click', () => {
            this.playing = !(this.togglePointerState ?? this.playing);
            this.togglePointerState = null;
            this.update();
          }, options);
          this.track.addEventListener('pointerdown', () => this.stop(), options);
          this.addEventListener('focusin', () => this.stop(), options);
          this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } }, options);
          this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, options);
          this.track.addEventListener('keydown', event => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.go(event.key === 'ArrowLeft' ? -1 : 1, true);
          }, options);
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
              this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
              this.querySelector('[data-current]').textContent = String(this.index + 1);
            }, 100);
          }, options);
          document.addEventListener('visibilitychange', () => this.schedule(), options);
          this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, options);
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          }, { threshold: .25 });
          this.observer.observe(this);
          this.resizeObserver = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
          this.resizeObserver.observe(this.track);
          this.update();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        else this.initialize();
      }
      stop() { this.playing = false; this.update(); }
      update() {
        this.querySelector('[data-toggle]').setAttribute('aria-label', this.playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.querySelector('[data-toggle-icon]').textContent = this.playing ? 'Ⅱ' : '▷';
        this.querySelector('.fnps__counter').setAttribute('aria-live', this.playing ? 'off' : 'polite');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.playing && this.visible && !this.hovering && !document.hidden) this.timer = setTimeout(() => this.go(1, false), 6000);
      }
      go(direction, manual) {
        if (manual) this.stop();
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
        this.querySelector('[data-current]').textContent = String(this.index + 1);
        this.schedule();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
